import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=6ff4f124&scoped=true&"
import script from "./Home.js?vue&type=script&lang=js&"
export * from "./Home.js?vue&type=script&lang=js&"
import style0 from "./Home.scss?vue&type=style&index=0&id=6ff4f124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4f124",
  null
  
)

export default component.exports